import { tradeSalesKeys, useNodeService } from "@fero/hooks";
import { useQueryClient } from "@tanstack/react-query";

export const useRemoveSavedProductPrices = () => {
  const nodeService = useNodeService();
  const queryClient = useQueryClient();
  return nodeService.removeProductSalePrices.useMutation({
    onSuccess: (_, request) => {
      queryClient.invalidateQueries(
        tradeSalesKeys.purchaserProductPrices(
          request.body.organisationId,
          request.body.purchaserId ?? "",
        ),
      );
      queryClient.invalidateQueries(
        tradeSalesKeys.savedProductPrices(
          request.body.organisationId,
          request.body.purchaserId ?? "",
        ),
      );
    },
  });
};
